import React, { useEffect, useState } from "react";
import BreadCrumbComponent from "../modules/Breadcrumbs";
import "./impact.scss";
import Status from "../modules/Status";
import Input from "../modules/Input";
import RadioButtons from "../modules/RadioBtn";
import BtnSet from "./BtnSet";
import FooterText from "../modules/FooterText";
import TransitionAlerts from "../modules/Alerts";
import StaticItem from "../modules/StaticItem";
import StaticField from "../StaticField";
import { api } from "../../Services";
import ModalComponent from "../modules/Modal";
import GradientLoader from "../modules/Loader";
import { useSelector } from "react-redux";
import { GetBaseUrl } from "../modules/getBaseUrl";
import { useNavigate } from "react-router-dom";

function ImpactSurvey() {
  const navigate = useNavigate();
  const [alert, setAlert] = useState(false);
  const [percentage, setPercentage] = useState(0);
  const info = useSelector((state) => state.personal.personalInfo);

  const [impactData, setImpact] = useState({
    name: "",
    mobile: "",
    email: "",
    tutionFee: "",
    placement: "no",
    company: "",
    job: "",
    salary: "",
  });

  const [loading, setLoading] = useState(false);

  const tokenData = useSelector((state) => state.tokens.tokens);

  const fedSubmit = () => {
    setAlert(true);
    setTimeout(() => setAlert(false), 3000);
  };

  const submitData = async () => {
    setLoading(true);

    let data = {
      name: info.firstName,
      mobile: info.mobile,
      email: info.email,
      fee: impactData.tutionFee,
      job: impactData.placement,
      company: impactData.placement === "yes" ? impactData.company : "",
      position: impactData.placement === "yes" ? impactData.job : "",
      salary: impactData.placement === "yes" ? impactData.salary : "",
      status: "",
      parentApplicationId: tokenData.appId,
    };
    try {
      const users = await api.impactAssessment(data, tokenData.token);
      if (users.statusCode === 200) {
        setLoading(false);
        setAlert(true);
        setTimeout(() => setAlert(false), 3000);
        // dispatch(addTokenInfo(["applicationStatus", "Submitted"]));
        let url = GetBaseUrl(window.location.href);
        // window.location.replace(url + "/application/submitted-status");
        navigate("/application/submitted-status");
      }
    } catch (error) {
      console.error("Sorry something went wrong", error);
      // Handle error scenario
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const measureFields = () => {
    let total = 1;
    let count = 1;
    for (let i in impactData) {
      // count+=1
      if (impactData.placement === "yes") {
        if (i === "company" || i === "job" || i === "salary") {
          total += 1;
          console.log("total", total, i);
          if (impactData[i]) {
            count += 1;
          }
        }
      }
      if (
        i === "name" ||
        i === "mobile" ||
        i === "email" ||
        i === "tutionFee"
      ) {
        total += 1;
        console.log("total", total, i);

        if (impactData[i]) {
          count += 1;
        }
      }
    }
    let per = Math.floor(Math.abs((count / total) * 100).toFixed(2));
    console.log("in btn education", count, total, percentage, impactData);
    setPercentage(per);
  };
  const setImpactData = (type, e) => {
    let ID = impactData;
    ID[type] = e;
    setImpact({ ...ID });
  };
  useEffect(() => {
    measureFields();
  }, [impactData]);
  return (
    <div className="form-div impact-survey">
      <div className="bc">
        <BreadCrumbComponent list={["Home", "Impact Survey"]} />
      </div>
      <div className="form-title">Impact Survey</div>
      <div className="md-desc">
        Dear Scholar, We are glad to have made a small impact in your academic
        journey. We strongly believe that opportunity belongs to all and hence
        in order for us to access the impact our scholarship has had in your
        journey, we would request you to share
      </div>
      <Status count={percentage} />
      <div className="fields">
        <div className="field-set">
          <div className="set-title">Personal Details</div>
          <StaticField title={"Name"} value={info.firstName} />{" "}
          <StaticField title={"Mobile"} value={info.mobile} />{" "}
          <StaticField title={"Email"} value={info.email} />{" "}
          {/* <Input
            placeholder={"Name"}
            //   id="number"
            value={impactData.name}
            onChange={(e) => setImpact({ ...impactData, name: e })}
          /> */}
          {/* <Input
            placeholder={"Mobile"}
            id="number"
            value={impactData.mobile}
            onChange={(e) => setImpact({ ...impactData, mobile: e })}
          />{" "} */}
          {/* <Input
            placeholder={"Email"}
            id="email"
            value={impactData.email}
            onChange={(e) => setImpact({ ...impactData, email: e })}
          />{" "} */}
          <Input
            placeholder={`What was the total Tuition Fee of your ${[ "B.Tech", "B.E."].includes(tokenData?.registrationData?.degree)? 'Engineering' :'MBA' }} Program?`}
            id="number"
            inputType={"rupee"}
            value={impactData.tutionFee}
            onChange={(e) => setImpactData("tutionFee", e)}
          />
        </div>
        <div className="field-set">
          <div className="set-title">Campus Placement Details</div>
          <div className="field-title">Have you secured a job placement?</div>
          <div className="radio-item">
            <div className="radio-options">
              <div className="radio-option sub-option-text">
                <RadioButtons
                  onChange={(e) => setImpactData("placement", e)}
                  value={impactData.placement}
                  option={"yes"}
                />
                Yes
              </div>
              <div className="radio-option sub-option-text">
                <RadioButtons
                  onChange={(e) => setImpactData("placement", e)}
                  value={impactData.placement}
                  option={"no"}
                />
                No
              </div>
            </div>
          </div>
          {impactData.placement === "yes" ? (
            <>
              <Input
                placeholder={"Company Name"}
                value={impactData.company}
                disabled={impactData.placement === "no"}
                onChange={(e) => setImpactData("company", e)}
              />{" "}
              <Input
                disabled={impactData.placement === "no"}
                placeholder={"Job Title"}
                value={impactData.job}
                onChange={(e) => setImpactData("job", e)}
              />{" "}
              <Input
                placeholder={"Annual Salary (Optional)"}
                id="number"
                disabled={impactData.placement === "no"}
                inputType={"rupee"}
                value={impactData.salary}
                onChange={(e) => setImpactData("salary", e)}
              />
            </>
          ) : (
            <>
              <StaticField
                title={"Company Name"}
                value={impactData.placement === "yes" ? impactData.company : ""}
              />{" "}
              <StaticField
                title={"Job Title"}
                value={impactData.placement === "yes" ? impactData.job : ""}
              />{" "}
              <StaticField
                title={"Annual Salary (Optional)"}
                value={impactData.placement === "yes" ? impactData.salary : ""}
              />
            </>
          )}
        </div>
      </div>
      <BtnSet onSubmit={() => submitData()} />
      {/* <FooterText/> */}
      <TransitionAlerts
        isAlert={alert}
        message={"Thanks for Your valuable Information"}
      />
      {loading && (
        <ModalComponent
          className={"loader-model"}
          show={loading}
          // handleClose={() => CancelData()}
          // title={ModalData.title}
          // content={ModalData.desc}
        >
          <GradientLoader />
        </ModalComponent>
      )}
    </div>
  );
}

export default ImpactSurvey;
